import React from 'react';
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import { FlexibleCoberturas } from 'containers/Hogar/HogarFlex/FlexibleCoberturas';
import { InfoGeneralFlexible } from 'containers/Hogar/HogarFlex/InfoGeneralFlexible';
import HogarOpcionesPago from 'containers/Hogar/HogarOpcionesPago';
import HogarRecuperarCotizacion from 'containers/Hogar/HogarRecuperarCotizacion';
import HogarEmisionAsegurado from 'containers/Hogar/emision/HogarEmisionAsegurado';
import HogarEmisionContratante from 'containers/Hogar/emision/HogarEmisionContratante';
import { HogarEmisionVigencia } from 'containers/Hogar/emision/HogarEmisionVigencia';
import HogarCoberturas from 'containers/Hogar/HogarCoberturas';
import HogarDatosAsegurado from 'containers/Hogar/HogarDatosAsegurado';
import { Hogar } from 'containers/Hogar/constantes/general';

const HOGAR_ROUTES = [
  <LayoutRoute
    exact={true}
    path={`${Hogar.urls.datosPersonales}/:idCotizacion?`}
    layout={HomePublicaLayout}
    component={HogarDatosAsegurado}
    validations={{
      prePolizaPagada: true,
    }}
  />,
  <LayoutRoute
    exact={true}
    path={`${Hogar.urls.coberturas}/:idCotizacion?`}
    layout={HomePublicaLayout}
    component={HogarCoberturas}
    validations={{
      prePolizaPagada: true,
    }}
  />,
  <LayoutRoute
    exact={true}
    path={`${Hogar.urls.opcionPago}/:idCotizacion?`}
    layout={HomePublicaLayout}
    component={HogarOpcionesPago}
    validations={{
      prePolizaPagada: true,
    }}
  />,
  <LayoutRoute
    exact={true}
    path={`${Hogar.urls.emisionContratante}`}
    layout={HomePublicaLayout}
    component={HogarEmisionContratante}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${Hogar.urls.emisionAsegurado}`}
    layout={HomePublicaLayout}
    component={HogarEmisionAsegurado}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${Hogar.urls.vigenciaPoliza}`}
    layout={HomePublicaLayout}
    component={HogarEmisionVigencia}
    navBarTab="personas"
  />,

  <LayoutRoute
    exact={true}
    path={`${Hogar.urls.individualFlexible1}/:idCotizacion?`}
    layout={HomePublicaLayout}
    component={InfoGeneralFlexible}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${Hogar.urls.individualFlexible2}/:idCotizacion?`}
    layout={HomePublicaLayout}
    component={FlexibleCoberturas}
    navBarTab="personas"
  />,
  <LayoutRoute
    path={`${Hogar.urls.recuperar}`}
    layout={HomePublicaLayout}
    component={HogarRecuperarCotizacion}
    navBarTab="personas"
  />,
];

export default HOGAR_ROUTES;
